export default {
    getUploadProgress(state) {
        return (file) => (state.upload[file.name]) ? state.upload[file.name].progress : 0
    },
    getUploadState(state) {
        return (file) => state.upload[file.name]
    },
    getUserType(state) {
        return state.userType
    }
}
